<template>
  <v-container fluid>
    <v-dialog 
      v-model = "createReceiverDialog" 
      width="700">
      <v-card>
        <v-card-title
          class="headline"
          primary-title>
          Fetch Receivers
        </v-card-title>
        <v-card-text>
          <v-form ref = "addFormRef">
          	<conditional-filters v-model = "filters" />
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createReceiverDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="addNewReceiver">
            Fetch
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteReceiverDialog" 
      width="400">
      <v-card v-if = "selected.length">
        <v-card-title
          class="headline"
          primary-title>
          Delete {{ selected.length }} Receivers?
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this receiver{{ selected.length > 1 ? 's' : '' }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="error"
            outline
            @click="deleteSelectedRecievers">
            Delete
          </v-btn>
          <v-btn
            color = "black"
            class = "white--text"
            @click="deleteReceiverDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card class = "card-curvey">
      	<v-layout 
          row 
          wrap>
          <h2>Receivers One by One</h2>
          <v-spacer />
          <v-btn
            color = "blue-grey"
            class = "nlp-nav-btn"
            :disabled = "!selected.length"
            small
            outline
            @click = "openDeleteDialog">
            <v-icon>delete</v-icon>
            Delete Receivers
          </v-btn>
          <v-btn
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog">
            <v-icon>add</v-icon>
            Fetch Receivers
          </v-btn>

        </v-layout>
        <v-flex xs12 v-if = "receivers && receivers.receivers">
          <v-data-table
            v-model = "selected"
            :headers="headers"
            :items="receivers.receivers"
            :pagination.sync="$store.state.settings.pagination"
            item-key="_id"
            item-receiver="subscription_receiver"
            no-data-text = "No Receivers Available"
            class="elevation-1 nlp-data-table"
            select-all>
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr>
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  />
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.receiver_id }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
import ConditionalFilters from '../common/ConditionalFilters'
export default {
  name: 'BroadcastReceivers',
  components: {
    ConditionalFilters
  },
  data() {
    return {
      selected: [],
      filters: [],
      deleteReceiverDialog: false,
      createReceiverDialog: false,
      toBeDeleted: null,
      headers: [
        {
          text: 'Receiver',
          align: 'left',
          sortable: true,
          value: 'receiver'
        },
        {
          text: 'Endpoint URL',
          value: 'endpoint_url'
        }
      ]
    }
  },
  mounted() {
    // get receivers
    this.getReceivers()
  },
  computed: {
    receivers() {
      return this.$store.state.broadcasts.broadcastReceivers
    },
    selectedBroadcast() {
      return this.$store.state.broadcasts.selectedBroadcast
    }
  },
  methods: {
    async getReceivers(callback = null) {
      await this.$store.dispatch(
        'broadcasts/get/current/receivers',
        this.$route.params.id
      )
    },
    openAddDialog(reset = true) {
      this.createReceiverDialog = true
    },
    addNewReceiver() {
      // add receiver
      this.$store.dispatch('setLoader', true)
      if (this.$refs.addFormRef.validate()) {
          const payload = this.filters.length ? this.filters : undefined
          this.$http_chat.post(`/broadcasts/${this.$route.params.id}/fetch-receivers`, payload).then(res => {
          	this.$store.dispatch('setLoader', false)
          	this.createReceiverDialog = false
          	this.$store.dispatch('setSnackbar', {
	            text: `Receiver Added Successfully`,
	            color: 'success'
	        })
          	this.getReceivers()
          }).catch((err)=>{
          	if(err && err.response && err.response.status === 400 && err.response.data && err.response.data.error)
	      		this.$store.dispatch('setErrorMessage', err.response.data.error)
	      	else this.$store.dispatch('setErrorMessage', true)
		      	this.$store.dispatch('setLoader', false)
	      })
      } else {
      	this.$store.dispatch('setLoader', false)
      	this.$store.dispatch('setErrorMessage', 'Invalid Input.')
      }
    },
    openDeleteDialog(receiver) {
    	// this.toBeDeleted = receiver
    	this.deleteReceiverDialog = true
    },
    async deleteSelectedRecievers() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.delete(`/broadcasts/${this.$route.params.id}/receivers?receivers=${ this.selected.map(r => r.receiver_id).join(',') }`).then(res => {
        this.deleteReceiverDialog = false
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
        })
        this.getReceivers()
      }).catch((err)=>{
        this.$store.dispatch('setLoader', false)
        if(err && err.response && err.response.status === 400)
          this.$store.dispatch('setErrorMessage', err.response.data.error)
        else this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

